module.exports = __webpack_public_path__ + "static/media/_DSC6129.69f607e2.jpg";